export const heroStats = [
  { label: '收录漫画', value: '50,000+' },
  { label: '日更新章节', value: '3,000+' },
  { label: '累计用户', value: '800万+' },
];

export const rankingItems = [
  { rank: 1, title: '斗罗大陆', author: '唐家三少', heat: '986万', tag: '玄幻', coverSeq: 'rank-01' },
  { rank: 2, title: '一人之下', author: '米二', heat: '872万', tag: '奇幻', coverSeq: 'rank-02' },
  { rank: 3, title: '镇魂街', author: '许辰', heat: '765万', tag: '热血', coverSeq: 'rank-03' },
  { rank: 4, title: '狐妖小红娘', author: '小新', heat: '698万', tag: '恋爱', coverSeq: 'rank-04' },
  { rank: 5, title: '全职高手', author: '蝴蝶蓝', heat: '654万', tag: '竞技', coverSeq: 'rank-05' },
  { rank: 6, title: '镖人', author: '许先哲', heat: '589万', tag: '武侠', coverSeq: 'rank-06' },
];

export const contactInfo = {
  title: '投稿与合作',
  description: '51漫画始终欢迎漫画作者、汉化组、版权方与我们取得联系。无论您是想投稿原创漫画作品、申请汉化授权，还是探讨商业合作，我们都将第一时间回复。',
  email: 'contact@51manhua.com',
  qq: '800123456',
  wechat: 'manhua51kf',
  tips: '工作日 9:00-18:00 在线回复，投稿请附作品样章与简介。',
};

export const faqItems = [
  {
    q: '如何免费下载漫画到手机？',
    a: '在51漫画APP或网站中，进入任意漫画详情页，点击「下载」按钮即可选择章节批量下载。下载完成后可在「我的下载」中离线阅读，无需消耗流量。',
  },
  {
    q: 'APP支持离线阅读吗？下载的漫画存在哪里？',
    a: '完全支持离线阅读。下载的漫画默认存储在手机内部存储的「51漫画」文件夹中，您可以在APP设置中自定义存储路径。所有下载内容经过加密处理，仅限APP内阅读。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常每周更新1-2话，部分日更漫画每天都有新内容。平台会在作者发布后2小时内同步更新，确保您第一时间看到最新章节。',
  },
  {
    q: '如何安装51漫画手机客户端？',
    a: '访问51漫画官网，点击「APP下载」按钮，根据手机系统选择Android或iOS版本。Android用户下载APK后直接安装；iOS用户跳转App Store下载。安装后注册即可使用全部功能。',
  },
  {
    q: '下载的漫画清晰度如何？收费吗？',
    a: '51漫画提供高清和超清两种画质选择，适配不同屏幕尺寸。平台所有漫画资源均免费下载和阅读，无隐藏收费，不设VIP专区，真正做到海量漫画全集免费畅享。',
  },
];

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20avatar%20portrait%20with%20spiky%20black%20hair%20and%20warm%20smile%20wearing%20casual%20hoodie%20against%20soft%20pastel%20orange%20gradient%20background%20clean%20digital%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '漫画狂人小陈',
    date: '2026-07-25',
    content: '用了三年51漫画了，资源是真的全！之前找了好几个APP都没有的冷门漫画，这里居然有全集。离线下载速度也快，通勤路上看漫画太爽了。强烈推荐给所有漫画党！',
    stars: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20young%20female%20avatar%20with%20long%20brown%20hair%20and%20gentle%20smile%20wearing%20white%20blouse%20against%20soft%20warm%20beige%20gradient%20background%20clean%20digital%20portrait%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '樱花落满肩',
    date: '2026-07-23',
    content: '作为一个恋爱漫画重度爱好者，51漫画的少女漫分类做得太好了。画质清晰，翻译质量也很高，完全没有机翻感。最重要的是真的免费！良心平台！',
    stars: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20male%20avatar%20with%20silver%20hair%20and%20sharp%20eyes%20wearing%20black%20jacket%20against%20subtle%20dark%20warm%20gradient%20background%20clean%20digital%20character%20portrait%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '夜行御史',
    date: '2026-07-20',
    content: '镖人、镇魂街这些国漫之光都在这里追的。更新速度没得说，基本作者刚发这边就能看了。离线功能出差必备，飞机高铁上刷漫画打发时间神器。',
    stars: 5,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cheerful%20female%20avatar%20with%20twin%20tails%20pink%20hair%20and%20bright%20eyes%20wearing%20casual%20yellow%20sweater%20against%20soft%20warm%20peach%20gradient%20background%20clean%20digital%20illustration%20portrait&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '糖分补给站',
    date: '2026-07-18',
    content: '从学生时代就开始用51漫画，现在工作了还在用。UI设计越来越好了，书架分类功能特别实用。而且没有烦人的弹窗广告，阅读体验比很多付费APP都好。',
    stars: 4,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20male%20avatar%20with%20short%20dark%20hair%20and%20glasses%20looking%20intellectual%20wearing%20navy%20shirt%20against%20soft%20warm%20gray%20gradient%20background%20clean%20digital%20portrait%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '纸片收藏家',
    date: '2026-07-15',
    content: '作为一个收集控，51漫画的漫画库简直是天堂。分类细致、搜索精准，想找什么类型的都能找到。离线下载后整理成册，感觉自己拥有了一个私人漫画图书馆。',
    stars: 5,
  },
];

export const appInfo = {
  title: '51漫画APP - 掌上漫画图书馆',
  description: '专为漫画爱好者打造的移动阅读客户端，支持Android与iOS双平台。海量漫画资源免费下载，随时随地离线畅读，流畅的阅读体验让每一页漫画都栩栩如生。',
  features: [
    { icon: 'ri-download-2-line', label: '免费下载', desc: '不限量高速下载' },
    { icon: 'ri-smartphone-line', label: '离线阅读', desc: '无需网络随时看' },
    { icon: 'ri-notification-3-line', label: '更新提醒', desc: '追更永不错过' },
    { icon: 'ri-bookmark-line', label: '智能书架', desc: '自动分类管理' },
  ],
  version: 'v6.8.2',
  size: '32.5MB',
};

export const updateItems = [
  { date: '2026-07-28', tag: '新作上线', title: '《深海回响》正式登陆51漫画，悬疑海洋探险题材引爆期待' },
  { date: '2026-07-27', tag: '版本更新', title: 'APP v6.8.2 发布：优化夜间模式，新增横屏翻页手势' },
  { date: '2026-07-26', tag: '热门更新', title: '《斗罗大陆》第358话更新，唐三突破封号斗罗境界' },
  { date: '2026-07-25', tag: '专题上线', title: '「国漫崛起」专题合辑上线，精选50部高分国产漫画' },
  { date: '2026-07-24', tag: '资源扩充', title: '漫画库突破5万部，新增200+部经典日漫全集资源' },
  { date: '2026-07-23', tag: '功能升级', title: '阅读器升级：支持智能分页、朗读模式、自定义背景色' },
  { date: '2026-07-22', tag: '合作公告', title: '与国内三大漫画平台达成内容合作，正版资源持续扩充' },
];

export const indexItems = [
  { icon: 'ri-fire-line', title: '热血漫画', count: '8,200+', desc: '战斗、冒险、成长，燃到爆的经典热血番' },
  { icon: 'ri-heart-line', title: '恋爱漫画', count: '6,500+', desc: '甜蜜、治愈、虐心，满足所有少女心' },
  { icon: 'ri-magic-line', title: '奇幻漫画', count: '5,800+', desc: '异世界、魔法、传说，想象力无边界' },
  { icon: 'ri-search-eye-line', title: '悬疑漫画', count: '3,200+', desc: '推理、惊悚、反转，烧脑停不下来' },
  { icon: 'ri-emotion-happy-line', title: '搞笑漫画', count: '7,100+', desc: '日常、无厘头、段子，笑到肚子疼' },
  { icon: 'ri-rocket-line', title: '科幻漫画', count: '2,900+', desc: '机甲、未来、宇宙，硬核科幻盛宴' },
  { icon: 'ri-vip-crown-line', title: '古风漫画', count: '4,600+', desc: '武侠、仙侠、宫廷，唯美古风世界' },
];

export const featureItems = [
  {
    icon: 'ri-database-2-line',
    title: '海量漫画资源',
    desc: '收录超过5万部漫画作品，涵盖热血、恋爱、奇幻、悬疑、搞笑、科幻、古风等全题材，热门冷门一应俱全。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '永久免费下载',
    desc: '所有漫画资源完全免费，支持批量高速下载，不限下载次数和数量，真正实现漫画自由。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '离线畅快阅读',
    desc: '下载后无需网络即可随时随地阅读，地铁、飞机、旅行途中都能畅享漫画世界。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速同步更新',
    desc: '热门连载漫画最快2小时内同步更新，追更永不错过，第一时间掌握剧情发展。',
  },
];

export const carouselItems = [
  {
    seq: 'carousel-01',
    title: '国漫崛起：不可错过的国产漫画精选',
    desc: '精选50部口碑与热度双高的国漫作品，从经典到新锐，见证国漫的黄金时代。',
    tag: '精选专题',
  },
  {
    seq: 'carousel-02',
    title: '热血战斗：燃到爆炸的格斗漫画合集',
    desc: '拳拳到肉的激战场面，令人窒息的剧情反转，最热血沸腾的战斗漫画都在这里。',
    tag: '热门推荐',
  },
  {
    seq: 'carousel-03',
    title: '悬疑烧脑：细思极恐的推理漫画特辑',
    desc: '层层递进的谜题设计，出人意料的真相揭露，挑战你的推理极限。',
    tag: '编辑精选',
  },
  {
    seq: 'carousel-04',
    title: '恋爱甜宠：少女心炸裂的恋爱漫画精选',
    desc: '从校园初恋到都市情缘，最甜最虐的恋爱故事，满足你对爱情的全部想象。',
    tag: '人气专题',
  },
  {
    seq: 'carousel-05',
    title: '奇幻异世界：脑洞大开的穿越漫画大全',
    desc: '从废柴逆袭到龙傲天开挂，最爽最过瘾的异世界冒险故事一网打尽。',
    tag: '新番速递',
  },
];

export const aboutInfo = {
  title: '关于51漫画',
  paragraphs: [
    '51漫画成立于2018年，是国内领先的免费漫画阅读与下载平台。我们致力于为广大漫画爱好者提供最全面、最便捷、最高质量的漫画阅读体验。经过多年发展，平台已收录超过5万部漫画作品，涵盖热血、恋爱、奇幻、悬疑、搞笑、科幻、古风等全品类题材，累计服务超过800万漫画读者。',
    '我们坚持「免费、全面、优质」的核心理念，所有漫画资源均可免费下载和阅读。平台与国内外多家漫画平台和独立作者建立了深度合作关系，确保内容的丰富性和更新速度。同时，自主研发的阅读引擎支持高清画质、智能分页和多种阅读模式，为用户带来极致的移动阅读体验。',
    '51漫画团队由一群热爱漫画的技术和内容人才组成。我们深知漫画不仅仅是一种娱乐方式，更是一种文化载体和情感寄托。未来，我们将继续扩充漫画资源库，优化产品体验，让每一位漫画爱好者都能在51漫画找到属于自己的精彩世界。',
  ],
};

export const topicItems = [
  { name: '国漫推荐', heat: '128万讨论' },
  { name: '日漫经典', heat: '96万讨论' },
  { name: '新番速递', heat: '83万讨论' },
  { name: '漫画改编', heat: '75万讨论' },
  { name: '冷门神作', heat: '62万讨论' },
  { name: '壁纸分享', heat: '58万讨论' },
  { name: '剧情讨论', heat: '51万讨论' },
  { name: '角色人气', heat: '47万讨论' },
  { name: '同人创作', heat: '39万讨论' },
  { name: '汉化进度', heat: '35万讨论' },
  { name: '完结推荐', heat: '31万讨论' },
];

export const mediaItems = [
  {
    seq: 'media-01',
    title: '《斗罗大陆》动画精彩片段',
    duration: '24:18',
    views: '128万',
  },
  {
    seq: 'media-02',
    title: '国漫作画过程揭秘',
    duration: '15:42',
    views: '96万',
  },
  {
    seq: 'media-03',
    title: '十大热血漫画名场面盘点',
    duration: '18:55',
    views: '85万',
  },
  {
    seq: 'media-04',
    title: '漫画作者访谈：创作背后的故事',
    duration: '32:10',
    views: '67万',
  },
];

export const cardItems = [
  {
    seq: 'card-01',
    title: '斗罗大陆',
    tag: '玄幻·热血',
    desc: '唐门外门弟子唐三，因偷学内门绝学而为唐门所不容。跳崖明志时却来到了另一个世界——斗罗大陆。',
    author: '唐家三少',
    status: '连载中',
    chapters: '358话',
    heat: '986万',
  },
  {
    seq: 'card-02',
    title: '一人之下',
    tag: '奇幻·冒险',
    desc: '普通大学生张楚岚，在爷爷坟前遭遇神秘少女冯宝宝，从此被卷入异人世界的纷争之中。',
    author: '米二',
    status: '连载中',
    chapters: '612话',
    heat: '872万',
  },
  {
    seq: 'card-03',
    title: '狐妖小红娘',
    tag: '恋爱·奇幻',
    desc: '以红娘为职业的狐妖，在为前世恋人牵红线续缘的过程中，发生的一系列有趣而感人的故事。',
    author: '小新',
    status: '连载中',
    chapters: '526话',
    heat: '698万',
  },
  {
    seq: 'card-04',
    title: '镖人',
    tag: '武侠·历史',
    desc: '大业三年，隋王朝在隋炀帝的暴政下风雨飘摇。身手不凡的镖客刀马行走于西域大漠，搅动天下风云。',
    author: '许先哲',
    status: '连载中',
    chapters: '118话',
    heat: '589万',
  },
  {
    seq: 'card-05',
    title: '全职高手',
    tag: '竞技·热血',
    desc: '网游荣耀中被誉为教科书级别的顶尖高手叶修，遭到俱乐部驱逐后，在网吧重新开始重返巅峰之路。',
    author: '蝴蝶蓝',
    status: '已完结',
    chapters: '全176话',
    heat: '654万',
  },
  {
    seq: 'card-06',
    title: '镇魂街',
    tag: '热血·奇幻',
    desc: '镇魂街是人界通向灵域的重要连接区域，每条街都有一位镇魂将守护。曹焱兵作为罗刹街的镇魂将，守护着一方安宁。',
    author: '许辰',
    status: '连载中',
    chapters: '398话',
    heat: '765万',
  },
];